// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationModal_background__qjUcK {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 100;
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 37.5em) {
  .NotificationModal_background__qjUcK {
    justify-content: center;
  }
}

.NotificationModal_container__JPTfG {
  width: 54rem;
  height: calc(100vh - 100pt);
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 3rem;
  position: relative;
  z-index: 400;
  top: 7rem;
  right: 17rem;
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 1rem;
}
@media only screen and (max-width: 37.5em) {
  .NotificationModal_container__JPTfG {
    right: 0rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .NotificationModal_container__JPTfG {
    width: 90vw;
  }
}

.NotificationModal_bws__ULc1Y {
  content: "";
  background-color: var(--color-white);
  width: 100%;
  height: 2rem;
}

.NotificationModal_content__ZIKBd {
  min-height: 75vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  width: 100%;
}
@media only screen and (max-width: 31.25em) {
  .NotificationModal_content__ZIKBd {
    min-height: fit-content;
  }
}

.NotificationModal_close__FZ7o8 {
  position: fixed;
  right: 3rem;
  cursor: pointer;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Modal/NotificationModal.module.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,aAAA;EAEA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAFD;AAGC;EARD;IASE,uBAAA;EAAA;AACF;;AAGA;EACC,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAAD;AAEC;EAfD;IAgBE,WAAA;EACA;AACF;AACC;EAnBD;IAoBE,WAAA;EAEA;AACF;;AACA;EACC,WAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAED;;AACA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAED;AAAC;EARD;IAUE,uBAAA;EAEA;AACF;;AACA;EACC,eAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAED","sourcesContent":["@import '../variables/breakpoints';\n\n.background {\n\twidth: 100vw;\n\theight: 100vh;\n\t// background-color: rgba(#2a2828, 0.4);\n\tposition: fixed;\n\tz-index: 100;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\t@media only screen and (max-width: $bp-600) {\n\t\tjustify-content: center;\n\t}\n}\n\n.container {\n\twidth: 54rem;\n\theight: calc(100vh - 100pt);\n\tbackground-color: var(--color-white);\n\tbox-sizing: border-box;\n\tbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\tpadding: 3rem;\n\tposition: relative;\n\tz-index: 400;\n\ttop: 7rem;\n\tright: 17rem;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\tborder-radius: 1rem;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tright: 0rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\twidth: 90vw;\n\t}\n}\n\n.bws {\n\tcontent: '';\n\tbackground-color: var(--color-white);\n\twidth: 100%;\n\theight: 2rem;\n}\n\n.content {\n\tmin-height: 75vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tz-index: 1;\n\twidth: 100%;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\t// margin: 3rem 0 8rem 0;\n\t\tmin-height: fit-content;\n\t}\n}\n\n.close {\n\tposition: fixed;\n\tright: 3rem;\n\tcursor: pointer;\n\tz-index: 10;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `NotificationModal_background__qjUcK`,
	"container": `NotificationModal_container__JPTfG`,
	"bws": `NotificationModal_bws__ULc1Y`,
	"content": `NotificationModal_content__ZIKBd`,
	"close": `NotificationModal_close__FZ7o8`
};
export default ___CSS_LOADER_EXPORT___;
